import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Header from "@/sections/Header";
import CaseStudy from "@/sections/CaseStudy";
import FooterSection from "@/sections/Footer";

export default function CaseStudyPage() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
    const previousTitle = document.title;
    document.title = "Case Study — DCYB Ventures";
    return () => { document.title = previousTitle; };
  }, []);

  return (
    <main data-testid="case-study-page" className="relative">
      <Header />
      <div className="border-b hairline bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6">
          <Link to="/" data-testid="case-study-back-home-link" className="inline-flex items-center gap-2 font-mono-label text-[11px] text-[#5F6168] hover:text-[#0F1117] transition-colors">
            <ArrowLeft size={14} aria-hidden="true" />Back to DCYB
          </Link>
        </div>
      </div>
      <CaseStudy />
      <FooterSection />
    </main>
  );
}